import React, { useContext } from 'react';
import Layout from '../../../../styles/Layout.styled';
import * as Styled from './HorizontalSpacer.styled';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
// Renders a wrapper which is meant to be a child of a Layout component
// A vertical comfortable size container renders a grid between the first and last columns of a parent grid,
// making the left and right feel roomy
//
// This should be rendered at the top level of a component!
var HorizontalSpacer = function (_a) {
    var _b = _a.isHorizontalComfortableSize, isHorizontalComfortableSize = _b === void 0 ? false : _b, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, isTenColumnGrid = _a.isTenColumnGrid, dataLabel = _a.dataLabel;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return isHorizontalComfortableSize ? (React.createElement(Layout, { "data-label": dataLabel, "$styleQueryMode": styleQueryMode, className: className },
        React.createElement(Styled.Comfortable, { "$styleQueryMode": styleQueryMode, isTenColumnGrid: isTenColumnGrid }, children))) : (React.createElement(Styled.Compact, { "data-label": dataLabel, "$styleQueryMode": styleQueryMode, className: className, isTenColumnGrid: isTenColumnGrid }, children));
};
export default HorizontalSpacer;
